import { dataMysql } from '../../util/util';

// Regras puras do botão Salvar do orçamento (16/10 — "o Salvar travou e o orçamento não ficou").

// O salvar converte as datas no próprio estado. Se o envio falhava, a segunda tentativa convertia
// de novo uma data já em AAAA-MM-DD e mandava "Invalid date". Data já convertida fica como está.
export function dataParaMysql(valor) {
    if (!valor) return null;
    if (/^\d{4}-\d{2}-\d{2}/.test(String(valor))) return valor;
    return dataMysql(valor);
}

// Depois do POST (orçamento novo ou cópia), a tela precisa ir para o id criado pelo roteador:
// com replaceState o `id` da rota não mudava e o Salvar seguinte criava outro orçamento.
export function destinoAposInserir({ id, copiar, novoId }) {
    const inseriu = !id || !!copiar;
    if (!inseriu) return { orcamentoId: id, irPara: null };
    return { orcamentoId: novoId, irPara: `/cadastroOrcamento/${novoId}` };
}

// Erro do Salvar com o que fazer: antes era "Erro:  ao carregar dados" para tudo, inclusive queda de
// conexão — a pessoa não sabia se tinha salvo nem que os dados continuavam na tela.
export function mensagemErroSalvar(error) {
    if (error?.code === 'ECONNABORTED') {
        return 'O servidor não confirmou o salvamento em 90 segundos. Clique em Salvar de novo — se o primeiro envio chegou, nada será duplicado.';
    }
    const doServidor = error?.response?.data?.error;
    if (doServidor) return `Não foi salvo: ${doServidor}`;
    const continuam = 'Suas alterações continuam na tela e no rascunho — clique em Salvar de novo';
    // Código 0 = o navegador não recebeu resposta (queda de conexão); não é "erro no servidor".
    if (!error?.response || !error.response.status) return `Não foi salvo: sem conexão com o servidor. ${continuam}.`;
    return `Não foi salvo: erro no servidor (${error.response.status}). ${continuam}; se repetir, avise o suporte.`;
}

// D-0052 parte 4b (Rafael, 23/10): a versão que a tela carregou vai junto do Salvar. Se outra pessoa
// salvou depois, a API recusa com 409. Vai SEMPRE (null = orçamento ainda sem chave): o campo ausente é
// o que a API entende como tela antiga, que não é conferida.
export function chaveSalvarBase(dados) {
    const chave = dados ? dados.chave_salvar : null;
    return typeof chave === 'string' && chave.trim() !== '' ? chave : null;
}

/** 409 "outra pessoa salvou este orçamento depois que você abriu" → { mensagem, nome, salvoEm } | null. */
export function conflitoDoErroSalvar(error) {
    const resposta = error && error.response;
    if (!resposta || resposta.status !== 409) return null;
    const corpo = resposta.data || {};
    const conflito = corpo.conflito;
    if (!conflito || conflito.codigo !== 'SALVO_POR_OUTRO') return null;
    const mensagem = typeof corpo.error === 'string' && corpo.error.trim() !== ''
        ? corpo.error.trim()
        : 'Outra pessoa salvou este orçamento depois que você abriu. Recarregue antes de salvar.';
    return { mensagem, nome: conflito.nome || null, salvoEm: conflito.salvo_em || null };
}

// Parte 2 (16/10): o Salvar desiste em 90 s e pede para salvar de novo. O servidor só não duplica
// porque o reenvio leva a MESMA chave (ChaveSalvarOrcamento no back) — e só quando o conteúdo é o
// mesmo: se a pessoa editou entre um envio e outro, chave nova, senão a edição nova seria ignorada.
export const TEMPO_LIMITE_SALVAR_MS = 90000;

function assinatura(conteudo) {
    const texto = JSON.stringify(conteudo) || '';
    let h = 5381;
    for (let i = 0; i < texto.length; i++) h = ((h * 33) ^ texto.charCodeAt(i)) >>> 0;
    return `${texto.length}-${h.toString(36)}`;
}

function novaChave() {
    if (typeof window !== 'undefined' && window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
    }
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}

// Parte 3 (19/10): `prefixo` = marca da tela ("<sessão>_<seq>", useRascunhoOrcamento.marcaSalvar). O
// servidor usa essa marca para ignorar um envio de rascunho desta tela que saiu antes do Salvar e só
// chegou depois dele. Chave final: "<sessão>_<seq>_<uuid>" (até 59 caracteres; o limite é 64).
const PREFIXO_VALIDO = /^[A-Za-z0-9]{8,20}_\d{1,9}$/;

export function chaveSalvarPara(conteudo, anterior, prefixo) {
    const ass = assinatura(conteudo);
    if (anterior && anterior.assinatura === ass) return anterior;
    const chave = PREFIXO_VALIDO.test(String(prefixo || '')) ? `${prefixo}_${novaChave()}` : novaChave();
    return { chave, assinatura: ass };
}
